export type ProviderEventType = BaseEventType | ChatEventType;
export enum BaseEventType {
	CLOSE = 'close',
	OPEN = 'open',
	ERROR = 'error',
	MESSAGE = 'message'
}

export enum ChatEventType {
	CHAT_MESSAGE = 'chat_message',
	CHAT_ERROR = 'chat_error',
	CHAT_ECHO = 'chat_echo'
}
